import { useParams } from 'react-router-dom';
import Layout from '@/components/feature/Layout';
import useDocumentMeta from '@/hooks/useDocumentMeta';
import NotFound from '@/pages/NotFound';
import HorizontalDetail from '@/pages/project-detail/components/HorizontalDetail';
import { projects } from '@/mocks/site';

export default function ProjectDetailPage() {
  const { slug } = useParams();
  const index = projects.findIndex((p) => p.slug === slug);
  const found = index === -1 ? null : projects[index];
  useDocumentMeta(
    found ? `${found.title} | ${found.finish} | MATERA Projects` : 'Page not found | MATERA',
    found
      ? `${found.title}: an exterior wall project by MATERA featuring ${found.finish}. See the surface, finish and detail photography.`
      : 'The page you were looking for does not exist or has moved.',
  );
  if (index === -1) return <NotFound />;
  const p = projects[index];
  const prev = projects[(index - 1 + projects.length) % projects.length];
  const next = projects[(index + 1) % projects.length];

  return (
    <Layout>
      {/* key by slug: switching projects fully unmounts the old pin and builds a fresh one */}
      <HorizontalDetail key={p.slug} p={p} prev={prev} next={next} />
    </Layout>
  );
}